// extracted by css-extract-rspack-plugin
export default {"spinnerBox":"SbzPahfo","PreloaderAnimation":"WreCZn8S"};